/*jslint browser: true*/
'use strict';

let $pageContainer, $detailsContainer;

export function loadControlLevelSettings(controlLevelID) {

    var detailsURL = '/pages/settings_control_level_detailed.cfm?' + $.param({
        controlLevelID: controlLevelID,
    });

    $.ajax({
        type: 'GET',
        url: detailsURL,
        dataType: 'html',
        cache: false,
        success: function (data) {
            $detailsContainer.html(data);
        },
        error: function (data) {
            console.log(data);
        },
    });

}

export function addNewControlLevel() {

    var popURL = '/pages/settings_control_levels_pop_add.cfm?' + jQuery.param({
        'new': 'true',
    });

    popWin({
        title: 'Add New Company',
        noAutoWidth: true,
        width: 450,
        height: 270,
        page: popURL,
        modal: true,
    });

}

export function deleteControlLevel(controlLevelID) {

    var popURL = '/pages/settings_control_levels_pop_delete.cfm?' + jQuery.param({
        'controlLevelID': controlLevelID,
    });

    popWin({
        title: 'Delete Company Confirmation',
        noAutoWidth: true,
        width: 450,
        page: popURL,
        modal: true,
    });

}

export function setupBinds() {

    /*
        Save current company value when in focus if use
        decides to not change - Might be better way to do this.
    */
    var companyLastSel = $pageContainer.find('[name="controlLevel"]').val();

    // Change Company
    $pageContainer.find('[name="controlLevel"]').bind('change', function (event) {
        event.preventDefault();

        var controlLevelID = $(this).val();

        if (companySettingschanged) {

            $(this).val(companyLastSel);

            confirmationPopup({
                contents: 'Unsaved changes - Are you sure you want to leave?',
                yes: function() {
                    loadControlLevelSettings(controlLevelID);
                    $pageContainer.find('[name="controlLevel"]').val(controlLevelID);
                    companySettingschanged = false;
                    settingsPageCheckSaveIcon();
                },
            });
        } else {
            loadControlLevelSettings(controlLevelID);
            companyLastSel = $(this).val();
        }
    });

    // Add New Company
    $pageContainer.find('.js-add-company').bind('click', (event) => {
        event.preventDefault();
        addNewControlLevel();
    });
}

export function setupDetailsBinds() {
    $('#js-save-billing-centre').bind('click', (event) => {
        event.preventDefault();
        saveForm('frmControlLevelDetails');
    });
}

export function initDetailsPage() {
    $('button').button();
    setupDetailsBinds();
}

export function init(options) {

    if (!options) {options = {};}
    if (!options.pageContainer) {
        options.pageContainer = '#settings-control-levels-container';
    }
    if (!options.detailsContainerSelector) {
        options.detailsContainerSelector = '#settings-control-level-details';
    }

    // Save Key Objects
    $pageContainer = $(options.pageContainer);
    $detailsContainer = $(options.detailsContainerSelector);

    // Setup Binds
    setupBinds();

}